<template>
  <svg viewBox="5 5 40 40">
    <g id="onderneming">
      <line class="st0" x1="6.23" y1="43.09" x2="43.65" y2="43.09" />
      <polyline
        class="st0"
        points="7.48,42.84 7.48,16.09 23.29,16.09 23.29,43.09 	"
      />
      <polyline
        class="st0"
        points="13.23,42.97 13.23,37.47 17.6,37.47 17.6,43.15 	"
      />
      <line class="st0" x1="11.1" y1="19.15" x2="11.1" y2="22.65" />
      <line class="st0" x1="15.42" y1="19.15" x2="15.42" y2="22.65" />
      <line class="st0" x1="19.73" y1="19.15" x2="19.73" y2="22.65" />
      <line class="st0" x1="11.1" y1="25.15" x2="11.1" y2="28.65" />
      <line class="st0" x1="15.42" y1="25.15" x2="15.42" y2="28.65" />
      <line class="st0" x1="19.73" y1="25.15" x2="19.73" y2="28.65" />
      <line class="st0" x1="11.1" y1="31.15" x2="11.1" y2="34.65" />
      <line class="st0" x1="15.42" y1="31.15" x2="15.42" y2="34.65" />
      <line class="st0" x1="19.73" y1="31.15" x2="19.73" y2="34.65" />
      <polyline
        class="st0"
        points="26.15,42.84 26.15,21.92 41.96,21.92 41.96,43.09 	"
      />
      <polyline
        class="st0"
        points="31.4,42.97 31.4,37.47 36.77,37.47 36.77,43.15 	"
      />
      <line class="st0" x1="29.77" y1="25.15" x2="29.77" y2="28.65" />
      <line class="st0" x1="34.08" y1="25.15" x2="34.08" y2="28.65" />
      <line class="st0" x1="38.4" y1="25.15" x2="38.4" y2="28.65" />
      <line class="st0" x1="29.77" y1="31.15" x2="29.77" y2="34.65" />
      <line class="st0" x1="34.08" y1="31.15" x2="34.08" y2="34.65" />
      <line class="st0" x1="38.4" y1="31.15" x2="38.4" y2="34.65" />
    </g>
    <g id="kader" class="st1">
      <g class="st2">
        <g>
          <g>
            <path
              class="st3"
              d="M46.5,1.09c1.47,0,2.66,1.19,2.66,2.66v42.72c0,1.47-1.19,2.66-2.66,2.66H3.77c-1.47,0-2.66-1.19-2.66-2.66
					V3.76c0-1.47,1.19-2.66,2.66-2.66H46.5 M46.5,0.09H3.77c-2.02,0-3.66,1.64-3.66,3.66v42.72c0,2.02,1.64,3.66,3.66,3.66H46.5
					c2.02,0,3.66-1.64,3.66-3.66V3.76C50.16,1.73,48.52,0.09,46.5,0.09L46.5,0.09z"
            />
          </g>
        </g>
        <rect x="5.65" y="5.76" class="st4" width="39" height="39" />
      </g>
      <g class="st2">
        <g>
          <path
            class="st3"
            d="M46.5,1.09c1.47,0,2.66,1.19,2.66,2.66v42.72c0,1.47-1.19,2.66-2.66,2.66H3.77c-1.47,0-2.66-1.19-2.66-2.66
				V3.76c0-1.47,1.19-2.66,2.66-2.66H46.5 M46.5,0.09H3.77c-2.02,0-3.66,1.64-3.66,3.66v42.72c0,2.02,1.64,3.66,3.66,3.66H46.5
				c2.02,0,3.66-1.64,3.66-3.66V3.76C50.16,1.73,48.52,0.09,46.5,0.09L46.5,0.09z"
          />
        </g>
      </g>
    </g>
  </svg>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class IconInfrastructuur extends Vue {}
</script>

<style scoped type="text/css">
.st0 {
  fill: none;
  stroke: #000000;
  stroke-miterlimit: 10;
}

.st1 {
  display: none;
}

.st2 {
  display: inline;
}

.st3 {
  fill: #0a0a0a;
}

.st4 {
  fill: none;
  stroke: #00aae1;
  stroke-miterlimit: 10;
}
</style>
